<template>
  <div slot="pageContent">

    <b-row>
      <div class="ml-2 mb-5 alert d-flex align-items-center" role="alert" style="color: #000000;background-color: rgb(236,236,236);">
        {{ $t('entities_setting_tb.description.responder') }}
      </div>
    </b-row>

    <web-service-configuration-form
        v-if="displayConfig"
        v-model="config"
        :readonly="!editMode"
        :mode="mode"
        :tb="tb"
        :CertificatServer="CertificatServer"
        :CAServer="CAServer">
    </web-service-configuration-form>
    <b-row class="justify-content-end">
      <b-col cols="2" v-if="mode === 'create' && demo">
        <b-button v-if="mode === 'create'"
                  @click="createConfig" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
      </b-col>
      <b-col cols="2" v-if="mode === 'details' && editMode === false && canEditConfig && demo">
        <b-button variant="primary"
                  @click="editModeActivate">
          <i class="fa-light fa-pencil"></i>
          <span>{{ $t('administration.edit') }}</span>
        </b-button>
      </b-col>
      <b-col cols="2" v-if="mode === 'details' && editMode === false && canDeleteConfig && demo">
        <b-button variant="primary"
                  @click="deleteConfig">
          <i class="fa-light fa-trash"></i>
          <span>{{ $t('rights.delete') }}</span>
        </b-button>
      </b-col>
      <b-col cols="2" v-if="mode === 'details' && editMode === true && demo">
        <b-button variant="primary"
                  @click="editConfig">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import WebServiceConfigurationForm from '@/pages/routing/WebServiceConfigurationForm.vue'

import {loadPage} from '@/helpers/routing'


export default {
  name: 'WebServiceConfigurationDetailsTB',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner,
    'web-service-configuration-form': WebServiceConfigurationForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    entitiesType: {
      type: String,
      default: "rvm"
    },
    tb: {
      type: String,
      default: "0"
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.rights.rightIs('webServiceConfig_delete', true)
    },
    canEditConfig () {
      return this.$engine.rights.rightIs('webServiceConfig_edit', true)
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.webservice_details') : this.$t('Webheader.webservice_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      demo: true,
      displayConfig: false,
      editMode: false,
      returnUrl: '',
      CAServer: '',
      CertificatServer: '',
      // returnUrl: this.entitiesType === 'rvm' ? '/entitiessettings/rvm/BICRVM' : `/entitiessettings/${this.entitiesType}/Corporate`,
      savedConfig: []
    }
  },
  created () {
    if (this.tb == 1){
      this.returnUrl = `/entitiessettingsTB/`

      let that = this

      let params = {}
      params.IdAccountTB = 1

      this.$engine.routing.config.webService.fetch(params).then(resp => {
        let webServiceList = resp.data.WebServiceConfig[0]

        if (this.mode === 'details') {
          this.savedConfig = webServiceList
          this.fillFields()
        } else {
          this.editMode = true
        }

        // Extraction des certificats encodés en Base64
        const base64Certs = [
          resp.data.Certificate1,
          resp.data.Certificate2,
          resp.data.Certificate3
        ]

        const cleanPem = (pem) => {
          try {
            let cleaned = atob(pem);
            // Enlève les guillemets autour s’ils existent
            if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
              cleaned = cleaned.slice(1, -1);
            }
            cleaned = cleaned.replace(/\\n/g, '\n');
            return cleaned;
          } catch (e) {
            console.error('Invalid base64:', pem);
            return '';
          }
        };

        const certServerPem = cleanPem(base64Certs[2])
        const caCertPem1 = cleanPem(base64Certs[1])
        const caCertPem2 = cleanPem(base64Certs[0])


        // Stocker les certificats
        this.CertificatServer = certServerPem
        this.CAServer = `${caCertPem1}\n${caCertPem2}`

        this.$f7.initPullToRefresh()
        this.activateSpinner = false
        this.$f7.pullToRefreshDone()
      })
          .catch(error => {
            errorMessageAlert(error, this)
          })

    }else{
      this.role = this.$route.query.role
      this.type = this.$route.query.type
      this.returnUrl = `/routing/configlist/${this.role}/${this.type}/${this.entitiesType}`
      this.activateSpinner = true

      if (this.mode === 'details') {
        this.savedConfig = this.$engine.routing.config.clickedConfig
        this.fillFields()
        this.$engine.routing.config.clickedConfig = {}
      } else {
        this.editMode = true
      }

      this.$f7.initPullToRefresh()
      this.activateSpinner = false
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === '1') {
        let paramsControl = {
        selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: 'SSL',
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          deliveredBy: this.config.certificateConfig.deliveredBy,
          deliveredTo: this.config.certificateConfig.deliveredTo,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod
        }

        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: that.config.privateKeysConfig.name,
            privateKey: that.config.privateKeysConfig.privateKey,
            password: that.config.privateKeysConfig.password,
            passwordVerif: that.config.privateKeysConfig.passwordVerif,
            type: that.config.privateKeysConfig.type,
            idPod: that.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          that.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.Host = that.config.host
            params.Port = that.config.port
            params.URI = that.config.uri
            params.SSLMode = that.config.sslActive
            params.Name = that.config.name
            params.idPrivateKey = respPrivateKey.data.idPrivateKey
            params.proxyActive = that.config.proxyActive

            if (that.config.proxyActive){
              params.proxyHost = that.config.proxyHost
              params.proxyPort = that.config.proxyPort
              params.proxyLogin = that.config.proxyLogin
              params.proxyPwd = that.config.proxyPwd
              params.proxyTunnel = that.config.proxyTunnel
              params.proxyConnectOnly = that.config.proxyConnectOnly
            }



            that.$engine.routing.config.webService.create(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: this.returnUrl})
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          login: this.config.login,
          password: this.config.password
          //idCertificate: respCertificate.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          //idPrivateKey: respPrivateKey.data.id
        }

        params.proxyActive = that.config.proxyActive

        if (that.config.proxyActive) {
          params.proxyHost = that.config.proxyHost
          params.proxyPort = that.config.proxyPort
          params.proxyLogin = that.config.proxyLogin
          params.proxyPwd = that.config.proxyPwd
          params.proxyTunnel = that.config.proxyTunnel
          params.proxyConnectOnly = that.config.proxyConnectOnly
        }

        this.$engine.routing.config.webService.create(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/WEBSERVICE/1'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdWebService: that.savedConfig.IdWebService
              }
              that.$engine.routing.config.webService.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let modeSecurity = this.getmodeSecurity()

      if (this.config.sslActive !== "0") {
        let params = {
          Type: "Config",
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password,
          Keystore: this.config.keystore,
          CA: this.config.ca,
          Timeout: this.config.timeout,
          ConnectTimeout: this.config.connectTimeout,
          ModeSecurity: modeSecurity,
          IdVopProvider: this.config.IdVopProvider,
          TBFlag: 1,
          updateMessageRouting: 1
        }

        if(this.tb == '1'){
          params.TOOLBOXFlag = 1
        }

        params.proxyActive = that.config.proxyActive

        if (that.config.proxyActive){
          params.proxyHost = that.config.proxyHost
          params.proxyPort = that.config.proxyPort
          params.proxyLogin = that.config.proxyLogin
          params.proxyPwd = that.config.proxyPwd
          params.proxyTunnel = that.config.proxyTunnel
          params.proxyConnectOnly = that.config.proxyConnectOnly
        }

        if (that.config.Cert) {
          params.Certificate = this.config.Cert
        }

        this.$engine.routing.config.webService.edit(params)
        .then(resp => {
          that.editMode = false
          that.$f7.modal({
            title: this.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          this.okMessageBox(this.$t('common.routing.config_edition_error'))
        })
        /*let paramsControl = {
        selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: this.config.certificateConfig.type,
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          commonName: this.config.certificateConfig.cn
          //idCertificate: this.savedConfig.idCertificate DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
        }
        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: this.config.privateKeysConfig.name,
            privateKey: this.config.privateKeysConfig.privateKey,
            password: this.config.privateKeysConfig.password,
            passwordVerif: this.config.privateKeysConfig.passwordVerif,
            type: this.config.privateKeysConfig.type
            //idPrivateKey: respPrivateKey.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          }
          this.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            let params = {
              Host: this.config.host,
              Port: this.config.port,
              URI: this.config.uri,
              SSLMode: this.config.sslActive,
              Name: this.config.name,
              IdWebService: this.savedConfig.IdWebService
            }
            this.$engine.routing.config.webService.edit(params)
            .then(resp => {
              that.$f7.modal({
                title: this.$t('common.routing.config_edited'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
            })
          })
        })*/
      } else {
        let params = {
          Type: 'Config',
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password,
          Timeout: this.config.timeout,
          ConnectTimeout: this.config.connectTimeout,
          ModeSecurity: modeSecurity,
          IdVopProvider: this.config.IdVopProvider,
          TBFlag: 1,
          updateMessageRouting: 1
        }
        params.proxyActive = that.config.proxyActive

        if (that.config.Cert) {
          params.Certificate = this.config.Cert
        }

        if (that.config.proxyActive){
          params.proxyHost = that.config.proxyHost
          params.proxyPort = that.config.proxyPort
          params.proxyLogin = that.config.proxyLogin
          params.proxyPwd = that.config.proxyPwd
          params.proxyTunnel = that.config.proxyTunnel
          params.proxyConnectOnly = that.config.proxyConnectOnly
        }
        this.$engine.routing.config.webService.edit(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_edition_error'))
        })
      }
    },
    getmodeSecurity () {
      let modeSecurity = 0
      if (this.config?.controlConfig?.selectedVerif && Array.isArray(this.config.controlConfig.selectedVerif)) {
        if (this.config.controlConfig.selectedVerif.length !== 0) {
          let dictionnary = {
            listVerifClientSSL: {
              1: { id: 1, text: this.$i18n.t('common.global.verify_peer'), value: 1 },
              2: { id: 2, text: this.$i18n.t('common.global.ctrl_CRL'), value: 32 },
              3: { id: 3, text: this.$i18n.t('common.global.ctrl_key_usage'), value: 8 },
              4: { id: 4, text: this.$i18n.t('common.global.ctrl_key_size'), value: 16 },
              5: { id: 5, text: this.$i18n.t('common.global.ctrl_expiration'), value: 1024 },
              6: { id: 6, text: this.$i18n.t('common.global.ctrl_CN'), value: 2048 }
            },
            listVerifServerSSL: {
              7: { id: 7, text: this.$i18n.t('common.global.ctrl_CA'), value: 2 },
              8: { id: 8, text: this.$i18n.t('common.global.ctrl_CRL'), value: 256 },
              9: { id: 9, text: this.$i18n.t('common.global.ctrl_key_usage'), value: 64 },
              10: { id: 10, text: this.$i18n.t('common.global.ctrl_key_size'), value: 128 },
              11: { id: 11, text: this.$i18n.t('common.global.ctrl_expiration'), value: 512 },
              12: { id: 12, text: this.$i18n.t('common.global.ctrl_CN'), value: 4096 }
            }
          }


          this.config.controlConfig.selectedVerif.forEach(element => {
            if (element > 6) {
              modeSecurity += dictionnary.listVerifServerSSL[element].value
            } else {
              modeSecurity += dictionnary.listVerifClientSSL[element].value
            }
          })
        }
      }


      return modeSecurity
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.timeout = this.savedConfig.Timeout
      this.config.connectTimeout = this.savedConfig.ConnectTimeout
      this.config.host = this.savedConfig.Host
      this.config.formatName = this.savedConfig.FormatName
      this.config.formatOutName = this.savedConfig.FormatOutName
      this.config.name = this.savedConfig.Name
      this.config.port = this.savedConfig.Port
      this.config.uri = this.savedConfig.URI
      this.config.sslActive = this.savedConfig.SSLMode
      this.config.login = this.savedConfig.Login
      this.config.password = this.savedConfig.Password
      this.config.keystore = this.savedConfig.Keystore
      this.config.ca = this.savedConfig.CA
      this.config.controlConfig = this.savedConfig.controlConfig
      this.config.proxyActive = this.savedConfig.proxyActive
      this.config.proxyHost = this.savedConfig.proxyHost
      this.config.proxyPort = this.savedConfig.proxyPort
      this.config.proxyLogin = this.savedConfig.proxyLogin
      this.config.proxyPwd = this.savedConfig.proxyPwd
      this.config.proxyTunnel = this.savedConfig.proxyTunnel
      this.config.proxyConnectOnly = this.savedConfig.proxyConnectOnly
      this.config.IdVopProvider = this.savedConfig.IdVopProvider
      this.config.Cert = this.savedConfig.Cert
      this.displayConfig = true
    },
    formHasError () {
      if (this.config.name === undefined || this.config.name.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.config.host === undefined || this.config.host.length === 0) {
        this.okMessageBox(this.$t('common.routing.host_missing'))
        return true
      }
      if (this.config.port === undefined || this.config.port.length === 0) {
        this.okMessageBox(this.$t('common.routing.port_missing'))
        return true
      }
      if ((this.config.uri === undefined || this.config.uri.length === 0) && this.tb == '1') {
        this.okMessageBox(this.$t('common.routing.uri_missing'))
        return true
      }
      if (this.config.sslActive === undefined || this.config.sslActive !== "0" && this.config.sslActive !== "1") {
        this.okMessageBox(this.$t('common.routing.wrong_ssl_active'))
        return true
      }
      if (this.config.sslActive === "1") {
        /*if (this.config.controlConfig === undefined || this.config.controlConfig.selectedVerif.length === 0) {
          this.okMessageBox(this.$t('common.global.ctrl_missing'))
          return true
        }
        if (this.config.certificateConfig === undefined) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.name === undefined || this.config.certificateConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.certificate === undefined || this.config.certificateConfig.certificate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_desc_missing'))
          return true
        }
        if (this.config.certificateConfig.type === undefined || this.config.certificateConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.certif_type_missing'))
          return true
        }
        if (this.config.certificateConfig.password === undefined || this.config.certificateConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.certificateConfig.passwordVerif === undefined || this.config.certificateConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }
        if (this.config.certificateConfig.startDate === undefined || this.config.certificateConfig.startDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_valid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.endDate === undefined || this.config.certificateConfig.endDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_unvalid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.cn === undefined || this.config.certificateConfig.cn.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_cn_missing'))
          return true
        }
        if (this.config.privateKeysConfig === undefined) {
          this.okMessageBox(this.$t('common.securityffff'))
          return true
        }
        if (this.config.privateKeysConfig.name === undefined || this.config.privateKeysConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_name_missing'))
          return true
        }
        if (this.config.privateKeysConfig.privateKey === undefined || this.config.privateKeysConfig.privateKey.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
          return true
        }
        if (this.config.privateKeysConfig.type === undefined || this.config.privateKeysConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.priv_key_type_missing'))
          return true
        }
        if (this.config.privateKeysConfig.password === undefined || this.config.privateKeysConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.privateKeysConfig.passwordVerif === undefined || this.config.privateKeysConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }*/
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: this.returnUrl})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
